import _ from 'lodash'
import {permissionCodes} from 'modules/permissions/contants'
import React from 'react'
import {BsTrash} from 'react-icons/bs'
import {IoAddCircleOutline, IoAlertCircleOutline, IoList, IoPersonOutline, IoSettingsOutline,} from 'react-icons/io5'
import {withRouter} from 'react-router-dom'
import {compose, withProps} from 'recompose'
import {notFoundOnError, withAccessPermissions} from 'views/AppLocals/composers'
import {CustomKeys} from 'views/AppLocals/CustomKeys'
import {AppEntities} from 'views/AppLocals/enums'
import ExaminationContext from 'views/AppLocals/Exam/ExaminationContext'
import {createCheckPermissions} from 'views/AppLocals/factory/createCheckPermissions'
import {ContextActionTypes} from 'views/AppLocals/factory/createContextMenu'
import {CoHosts, CoOwners} from 'views/AppLocals/factory/createHostSetting'
import {createSettingModule} from 'views/AppLocals/factory/createModule'
import createDeleteEntity from '../../factory/createDeleteEntity'
import ExaminationSettingAbout from './ExaminationSettingAbout'
import ExaminationSettingInformation from './ExaminationSettingInformation'
import ExaminationSettingOverview from './ExaminationSettingOverview'
import ExaminationSettingQuestionSets from './ExaminationSettingQuestionSets'

const menuItems = [
  {
    key: 'overview',
    label: 'general settings',
    icon: <IoSettingsOutline />,
  },
  {
    key: 'about',
    label: 'about examination',
    icon: <IoAlertCircleOutline />,
  },
  {
    key: 'questions',
    label: 'questions set',
    icon: <IoList />,
  },
  {
    key: 'informations',
    label: 'additional information',
    icon: <IoAddCircleOutline />,
  },
  {
    key: 'hosts',
    label: 'hosts',
    icon: <IoPersonOutline />,
    children: [
      {
        label: 'governing organizations',
        key: CustomKeys.governing_organizations.name,
      },
    ],
  },
  {
    key: 'delete',
    label: 'delete',
    icon: <BsTrash />,
  },
]
  .filter(({ invisible = false }) => !invisible)
  .map(({ invisible, ...rest }) => rest)

const routeEntities = [
  {
    path: 'overview',
    label: 'overview',
    component: createCheckPermissions([])(ExaminationSettingOverview),
  },
  {
    path: 'about',
    label: 'about',
    component: createCheckPermissions([])(ExaminationSettingAbout),
  },
  {
    path: 'questions',
    label: 'questions set',
    component: createCheckPermissions([])(ExaminationSettingQuestionSets),
  },
  {
    path: 'informations',
    label: 'informations',
    component: createCheckPermissions([])(ExaminationSettingInformation),
  },
  {
    path: CustomKeys.governing_organizations.name,
    label: CustomKeys.governing_organizations.label,
    component: createCheckPermissions([])(CoHosts),
  },
  {
    path: 'host-request',
    label: 'host request',
    component: createCheckPermissions([])(CoOwners),
  },
  {
    path: 'delete',
    label: 'delete',
    component: createCheckPermissions([])(({ item }) =>
      createDeleteEntity(item)
    ),
  },
]
  .filter(({ invisible = false }) => !invisible)
  .map(({ path, component: Component, invisible, ...rest }) => ({
    ...rest,
    path,
    key: path,
    component: (props) => (
      <ExaminationContext.Consumer>
        {({ examination }) => (
          <Component
            {...{ item: examination }}
            {...props}
          />
        )}
      </ExaminationContext.Consumer>
    ),
  }))

export const examinationSettings = {
  actions: [
    {
      key: ContextActionTypes.SETTINGS,
      label: 'setting',
      icon: <IoSettingsOutline />,
    },
  ],
  menuItems,
  routeEntities,
}

const ExaminationSettings = ({ id, ...props }) =>
  createSettingModule([AppEntities.EXAMINATION], {
    item: id,
    ...props,
  })

export default compose(
  notFoundOnError(ExaminationContext.Consumer),
  withAccessPermissions([permissionCodes.canEdit]),
  withRouter,
  withProps(({ match }) => ({
    id: _.get(match, 'params.id'),
  }))
)(ExaminationSettings)
